import { EntityId } from '@reduxjs/toolkit';

export interface CouponProduct {
  type: AmountType.PRODUCT;
  value: string;
}

export interface CouponFlat {
  type: AmountType.FLAT;
  value: string;
  currency: CouponCurrencyType;
}

export interface CouponPercentage {
  type: AmountType.PERCENTAGE;
  value: string;
}

export enum CouponStateEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
export interface CouponUserItemInDTO {
  id: string;
  usedAt?: string;
  storeId?: string;
  userId: string;
  expirationDate: string;
  title: string;
  validityPeriod?: string;
  couponId: string;
  couponUserId: string;
  dateCreated: string;
  lastModified: string;
  terms?: string;
  description?: string;
  data: CouponProduct | CouponFlat | CouponPercentage;
  isClaimed: boolean;
  claimedDate?: string;
  storeListId: string;
  franchiseName?: string;
}

export interface CouponOutDTO {
  id?: string;
  title: string;
  terms?: string;
  data: CouponProduct | CouponFlat | CouponPercentage;
  validityPeriod: string;
}

export interface CouponInDTO extends CouponOutDTO {
  userId: string;
  dateCreated: string;
  lastModified: string;
  communicationCampaignId: EntityId;
}

export type CouponFormType = Pick<CouponInDTO, 'id' | 'title' | 'terms' | 'data' | 'validityPeriod'>;

export enum AmountType {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE',
  PRODUCT = 'PRODUCT',
}

export enum CouponCurrencyType {
  EUR = 'EUR',
  CAD = 'CAD',
  USD = 'USD',
  CHF = 'CHF',
}

export type CouponData = {
  value: string;
  type: AmountType;
  currency?: CouponCurrencyType;
};
